<p-dialog [modal]="true" [draggable]="false" [closable]="false" [header]="this.header" [(visible)]="dialogVisible" *ngIf="dialogVisible" [style]="{width: '800px'}" appendTo="body">
    <div class="ui-g">
        <p-tabView [activeIndex]="indexDimTotaling" (onChange)="handleChangeDimTotaling(3,$event)">
            <p-tabPanel header="Totaling List">
                <div class="ui-g-6 ui-md-6">
                    <p-treeTable #tt1 [value]="this.dimensionValues" [columns]="tableColumns" selectionMode="multiple"
                    [(selection)]="this.selected" dataKey="id" [contextMenu]="cm1" [scrollable]="true" scrollHeight="400px" >
                        <ng-template pTemplate="caption">
                            <input type="text" pInputText placeholder="Search..." (input)="tt1.filterGlobal($event.target.value, 'contains')" class="search-accounts-input">
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 30% !important;">Code</th>
                                <th style="width: 70% !important;">Name</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                            <tr [ttContextMenuRow]="rowNode" [ttSelectableRow]="rowNode">
                                <td style="width: 30% !important; word-wrap: break-word;">
                                    <p-treeTableToggler [rowNode]="rowNode">
                                    </p-treeTableToggler>
                                    {{rowData.code}}
                                </td>
                                <td style="width: 70% !important; word-wrap: break-word;">
                                    {{rowData.name}}
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td [attr.colspan]="tableColumns.length">No data found.</td>
                            </tr>
                        </ng-template>
                    </p-treeTable>
                    <p-contextMenu #cm1 [model]="items1" appendTo="body"></p-contextMenu>
                    <div class="ui-g-12">
                        <button pButton type="button" label="Select" class="pull-right" iconPos="right" icon="ui-icon-arrow-forward" (click)="pick()"></button>
                    </div>
                </div>
                <div class="ui-g-6 ui-md-6">
                    <p-treeTable #tt2 [value]="this.dimensionValuesSelected" [columns]="tableColumns" selectionMode="multiple"
                    [(selection)]="selectedRight" dataKey="id" [contextMenu]="cm2" [scrollable]="true" scrollHeight="400px">
                        <ng-template pTemplate="caption">
                            <input type="text" pInputText placeholder="Search..." (input)="tt2.filterGlobal($event.target.value, 'contains')" class="search-accounts-input">
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 30% !important;">Code</th>
                                <th style="width: 70% !important;">Name</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                            <tr [ttContextMenuRow]="rowNode" [ttSelectableRow]="rowNode">
                                <td style="width: 30% !important; word-wrap: break-word;">
                                    <p-treeTableToggler [rowNode]="rowNode">
                                    </p-treeTableToggler>
                                    {{rowData.code}}
                                </td>
                                <td style="width: 70% !important; word-wrap: break-word;">
                                    {{rowData.name}}
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td [attr.colspan]="tableColumns.length">No data found.</td>
                            </tr>
                        </ng-template>
                    </p-treeTable>
                    <p-contextMenu #cm2 [model]="items2" appendTo="body"></p-contextMenu>
                    <div class="ui-g-12">
                        <button pButton type="button" label="Remove" class="pull-left" iconPos="left" icon="ui-icon-arrow-back" (click)="unpick()"></button>
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Totaling Range">
                <div class="ui-g-12 ui-md-6">
                    <h4>From...</h4>
                    <p-treeTable #tr1 [value]="this.dimensionValuesRange1" [columns]="tableColumns" selectionMode="single"
                    [(selection)]="_selectedRange1" dataKey="id" [contextMenu]="cm3" [scrollable]="true" scrollHeight="400px" (click)="this.loadRange2()">
                        <ng-template pTemplate="caption">
                            <input type="text" pInputText placeholder="Search..." (input)="tr1.filterGlobal($event.target.value, 'contains')" class="search-accounts-input">
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 30% !important;">Code</th>
                                <th style="width: 70% !important;">Name</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                            <tr [ttContextMenuRow]="rowNode" [ttSelectableRow]="rowNode">
                                <td style="width: 30% !important; word-wrap: break-word;">
                                    <p-treeTableToggler [rowNode]="rowNode">
                                    </p-treeTableToggler>
                                    {{rowData.code}}
                                </td>
                                <td style="width: 70% !important; word-wrap: break-word;">
                                    {{rowData.name}}
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td [attr.colspan]="tableColumns.length">No data found.</td>
                            </tr>
                        </ng-template>
                    </p-treeTable>
                    <p-contextMenu #cm4 [model]="items3" appendTo="body"></p-contextMenu>
                </div>
                <div class="ui-g-12 ui-md-6">
                    <h4>...to</h4>
                    <p-treeTable #tr2 [value]="this.dimensionValuesRange2" [columns]="tableColumns" selectionMode="single"
                    [(selection)]="selectedRange2" dataKey="id" [contextMenu]="cm4" [scrollable]="true" scrollHeight="400px" [rows]="12"
                    [virtualScroll]="true" [virtualRowHeight]="56">
                        <ng-template pTemplate="caption">
                            <input type="text" pInputText placeholder="Search..." (input)="tr2.filterGlobal($event.target.value, 'contains')" class="search-accounts-input">
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 30% !important;">Code</th>
                                <th style="width: 70% !important;">Name</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                            <tr [ttContextMenuRow]="rowNode" [ttSelectableRow]="rowNode">
                                <td style="width: 30% !important; word-wrap: break-word;">
                                    <p-treeTableToggler [rowNode]="rowNode">
                                    </p-treeTableToggler>
                                    {{rowData.code}}
                                </td>
                                <td style="width: 70% !important; word-wrap: break-word;">
                                    {{rowData.name}}
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td [attr.colspan]="tableColumns.length">No data found.</td>
                            </tr>
                        </ng-template>
                    </p-treeTable>
                    <p-contextMenu #cm4 [model]="items4" appendTo="body"></p-contextMenu>
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>
    <div class="ui-g">
        <div class="ui-g-12">
            <button type="button" label="OK" pButton icon="ui-icon-check" (click)="okClick()" style="margin-right: 0.5em;"></button>
            <button type="button" label="Cancel" pButton icon="ui-icon-cancel"
                (click)="dialogVisible=false;"></button>
        </div>
    </div>
</p-dialog>



<div class="ui-g">
    <div class="ui-g-10 ui-lg-10 ui-md-10 ui-sm-10">
        <p-chips [(ngModel)]="this.totaling" (onRemove)= "onRemove()" (onChipClick)="showDialog($event)">
            <ng-template let-item pTemplate="item">
                <div pTooltip="{{item.Descriptions}}" [escape]=false>
                    <span>{{item.Names}}</span>
                </div>
            </ng-template>
        </p-chips>
    </div>
    <div class="ui-g-2 ui-lg-2 ui-md-2 ui-sm-2">
        <button type="button" (click)="showDialog($event)" pButton icon="pi pi-node" label="Pick"
            icon="pi pi-check"></button>
    </div>
</div>
